import { Dialog } from '@chakra-ui/react';
import { CSSProperties, ReactNode } from 'react';

import { ErrorBoundary } from 'shared_DEPRECATED/components/Error/ErrorBoundary';
import { GeneralWidgetError } from 'shared_DEPRECATED/components/Error/GeneralWidgetError';

type ModalBodyProps = {
  children: ReactNode;
  styles?: CSSProperties;
};

export const ModalBody = ({ children, styles }: ModalBodyProps) => (
  <Dialog.Body style={styles}>
    <ErrorBoundary FallbackComponent={GeneralWidgetError}>
      {children}
    </ErrorBoundary>
  </Dialog.Body>
);
